<template>
  <div class="stack-md">
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Типографика</h3>
      </div>
      <div class="widget__body">
        <div class="row flex-y-center">
          <h1 class="col-6">Заголовок h1</h1>
          <div class="col-3">32px / 36px</div>
          <div class="col-3">Roboto / Bold</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <h2 class="col-6">Заголовок h2</h2>
          <div class="col-3">26px / 32px</div>
          <div class="col-3">Roboto / Bold</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <h3 class="col-6">Заголовок h3</h3>
          <div class="col-3">18px / 24px</div>
          <div class="col-3">Roboto / Medium</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <h4 class="col-6">Заголовок h4</h4>
          <div class="col-3">16px / 24px</div>
          <div class="col-3">Roboto / Medium</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <div class="col-6">Body текст</div>
          <div class="col-3">16px / 24px</div>
          <div class="col-3">Roboto / Regular</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <div class="col-6 text-sm">Small текст</div>
          <div class="col-3">15px / 20px</div>
          <div class="col-3">Roboto / Regular</div>
        </div>
        <div class="divider"></div>
        <div class="row flex-y-center">
          <div class="col-6 text-xs">Extra small текст</div>
          <div class="col-3">14px / 20px</div>
          <div class="col-3">Roboto / Regular</div>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <div class="widget__title">Цвета</div>
      </div>
      <div class="widget__body">
        <h4 class="mb-12">Тема</h4>
        <div class="flex mb-24">
          <div class="color-box text-white bg-primary mr-24">$primary-color <br> hsl(210, 100%, 46%)</div>
          <div class="color-box text-white bg-primary-dark mr-24">$primary-dark-color</div>
          <div class="color-box text-white bg-primary-light">$primary-light-color</div>
        </div>
        <div class="flex mb-24">
          <div class="color-box text-base w-200 bg-primary-lightish mr-24">$primary-lightish-color</div>
          <div class="color-box text-base w-200 bg-primary-lightest mr-24">$primary-lightest-color</div>
        </div>
        <div class="divider"></div>
        <h4 class="mb-12">Состояния</h4>
        <div class="flex mb-24">
          <div class="color-box text-white bg-success mr-24">$success-color</div>
          <div class="color-box text-white bg-error">$error-color</div>
        </div>
        <div class="divider"></div>
        <h4 class="mb-12">Фон</h4>
        <div class="flex mb-24">
          <div class="color-box text-base bg-body mr-24">$body-bg-color</div>
        </div>
        <div class="divider"></div>
        <h4 class="mb-12">Текст</h4>
        <div class="stack-sm">
          <div><span>Regular текст</span></div>
          <div><span class="text-primary">Primary текст</span></div>
          <div><span class="text-muted">Muted текст</span></div>
          <div><span class="icon" v-html="require('@/assets/img/icons/exit.svg')"></span></div>
          <div><div class="border-box">$border-color</div></div>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Ссылки</h3>
      </div>
      <div class="widget__body">
        <div class="mr-24">
          <div class="mb-12">
            <a href="#">Ссылка без стилей</a>
          </div>
          <div class="mb-12">
            <a href="#" class="link">Ссылка со стилями</a>
          </div>
          <div class="mb-12">
            <a href="#" class="text-link">Ссылка под цвет текста</a>
          </div>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Кнопки</h3>
      </div>
      <div class="widget__body stack-sm">
        <div>
          <el-button type="primary" class="mr-12">Default</el-button>
          <el-button type="primary" size="medium" class="mr-12">Medium</el-button>
          <el-button type="primary" size="small">Small</el-button>
        </div>
        <div>
          <el-button type="primary" class="w-100">Full width</el-button>
        </div>
        <div>
          <el-button type="primary" plain>Plain</el-button>
        </div>
        <div>
          <el-button type="primary" :loading="true">Loading</el-button>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-search">Icon</el-button>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Инпуты</h3>
      </div>
      <div class="widget__body stack-sm">
        <div class="w-half">
          <el-form>
            <el-form-item label="Label" prop="login" class="mb-24">
              <el-input v-model="form.login" name="login" type="text" />
            </el-form-item>
            <el-input
              v-model="form.password"
              placeholder="Плейсхолдер"
              name="password"
              type="text"
              class="mb-24" />
            <el-input
              v-model="form.dis"
              :disabled="true"
              name="dis"
              placeholder="Disabled"
              type="text"
              class="mb-24" />
            <el-input
              v-model="form.dis"
              prefix-icon="el-icon-search"
              name="dis"
              placeholder="Иконка"
              type="text"
              class="mb-24" />
            <el-input
              v-model="form.login"
              placeholder="Medium size"
              size="medium"
              type="text"
              class="mb-24" />
            <el-input
              v-model="form.login"
              placeholder="Small size"
              size="small"
              type="text" />
          </el-form>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Селект</h3>
      </div>
      <div class="widget__body stack-sm">
        <div>
          <el-select v-model="select" clearable>
            <el-option label="Один" value="Один">Один</el-option>
            <el-option label="Два" value="Два">Два</el-option>
            <el-option label="Три" value="Три">Три</el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="select" disabled>
            <el-option label="Один" value="Один">Один</el-option>
            <el-option label="Два" value="Два">Два</el-option>
            <el-option label="Три" value="Три">Три</el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Чекбоксы</h3>
      </div>
      <div class="widget__body stack-sm">
        <div>
          <el-checkbox v-model="notChecked" />
        </div>
        <div>
          <el-checkbox v-model="checked">Checked</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="disCheckbox" disabled>Disabled</el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          login: '',
          password: '',
          dis: ''
        },
        select: '',
        checked: true,
        notChecked: false,
        disCheckbox: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .color-box {
    width: 150px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
  }

  .border-box {
    height: 50px;
    width: 130px;
    border: 2px solid $border-color;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .w-200 {
    width: 200px;
  }
</style>
